export function squareSlider() {
    let $slider = $(".square-slider");
    $slider.slick({
        infinite: true,
        cssEase: "linear",
        speed: 500,
        arrows: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        variableWidth: true,
        responsive: [
            {
                breakpoint: 9999,
                settings: {
                    variableWidth: true
                }
            },
            {
                breakpoint: 768,
                settings: {
                    infinite: true,
                    cssEase: "linear",
                    speed: 500,
                    arrows: true,
                    dots: true,
                }
            }
        ]
    });
}


// WEBPACK FOOTER //
// ./assets/js/modules/squareSlider.js